import initializeWebsite from "./modules/initialize.website";
import initializeMobileNav from "./modules/mobile-nav";
import initializeSubLists from "./modules/Initialize.list-sub";
import initializeSliders from "./modules/initialize.slider";
import initializeScrollButton from "./modules/initialize.scroll-button";
import initializeNavigationScroll from "./modules/initialize.navigation-scroll";

// outdatedbrowser
function addLoadEvent(func) {
    let oldonload = window.onload;
    if (typeof window.onload != 'function') {
        window.onload = func;
    } else {
        window.onload = function() {
            if (oldonload) {
                oldonload();
            }
            func();
        }
    }
}

window.addEventListener('load', () => {
  const popups = document.querySelectorAll('.popup');

  if (popups.length) {
    popups.forEach(popup => {
      const cross = popup.querySelector('.popup__cross');
      
      cross.addEventListener('click', () => {
        popup.classList.add('-hide');
      });
    });
  }
})

//call plugin function after DOM ready
addLoadEvent(function(){
    console.log('outdated browser plugin');
    outdatedBrowser({
        bgColor: '#f25648',
        color: '#ffffff',
        lowerThan: (/*@cc_on!@*/ false || !!document.documentMode),
        languagePath: '/outdatedbrowser/lang/nl.html'
    });
});

window.addEventListener('DOMContentLoaded', () => {
  const website = document.getElementById('website');

  initializeWebsite(
    website
  );
  initializeNavigationScroll(
    website
  )

  initializeMobileNav(
    document.getElementById('mobile-menu-switch'),
    document.getElementById('mobile-nav')
  )

  initializeSubLists(
    document.querySelectorAll('.list, .list--horizontal')
  );

  initializeSliders(
    document.querySelectorAll('.slider')
  );

  const scrollDownButton = document.getElementById('scroll-down');
  if (scrollDownButton) {
    initializeScrollButton(
      scrollDownButton
    );
  }
});

// window.Vue = require("vue");
import Vue from 'vue'

import WoningSelector from "./components/woning-selector";

Vue.component('WoningSelector', WoningSelector);

const app = new Vue({
  el: "main",
});


let faqQuestion;
const faqItems = document.querySelectorAll('.faq--item');

faqItems.forEach((faqItem) => {
  faqQuestion = faqItem.querySelector('.faq--question');
  faqQuestion.addEventListener('click', () => {
    faqItem.classList.toggle('active');
  })
});

loadCheckbox("check");

function loadCheckbox(a) {
  let el = document.getElementsByClassName(a);
  for (let i = 0; i < el.length; i++) {
    let span = document.createElement("span");
    span.className = "checkmark";
    let checkbox = el[i].appendChild(span);
  }
}
